import React from "react";
import PeopleHeader from "./PeopleHeader";
import PopularPeople from "./PopularPeople";

const People = () => {
  return (
    <>
      <PeopleHeader />
      <PopularPeople />
    </>
  );
};

export default People;
